import { MessageDispatchEditScreen } from "./message-dispatch-edit.screen";
import { Paths } from "../../routes/paths";
import { type RouteDefinition } from "../../routes/route-definition";

export const MessageDispatchEditRoutes: RouteDefinition[] = [
	{
		path: Paths.messagesDispatches.withIdPlaceholder().edit.path,
		element: <MessageDispatchEditScreen />,
		requiredPermissions: ["UserInAccountPermission_MessageDispatchAdmin_Modify"],
	},
];
